/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Embed Job Confirmation" |
*
* @param {Embed_Captions_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_title = /** @type {((inputs?: Embed_Captions_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmation de tache d'incrustation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auftragsbestätigung einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora conferma lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить подтверждение задания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmación de trabajo incrustada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入式工作确认")
	if (locale === "ja") return /** @type {LocalizedString} */ ("求人確認を埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी की पुष्टि को एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar Confirmação de Trabalho")
	return /** @type {LocalizedString} */ ("Embed Job Confirmation")
});